<template>
	<div class="page-content__content">
		<CategoryAdminsTable/>
	</div>
</template>

<script>

import CategoryAdminsTable from "@/components/sections/CategoryAdmins/CategoryAdminsTable.vue";

export default {
	name: "CategoryAdminsPage",
	components: {CategoryAdminsTable},
}
</script>


